export const SLIDES_CACHE_KEY = 'khayr_public_slides_v6';

export const readSlidesCache = () => {
  try {
    const raw = localStorage.getItem(SLIDES_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
  } catch {
    return null;
  }
};

export const writeSlidesCache = (slides) => {
  try {
    localStorage.setItem(SLIDES_CACHE_KEY, JSON.stringify(slides));
  } catch {
    // ignore quota errors
  }
};

export const slidePreloadSrc = (slide) => slide?.imageWebp || slide?.image || null;

export const getCachedFirstSlideImage = () => slidePreloadSrc(readSlidesCache()?.[0]);

export const getCachedFirstSlidePreload = () => {
  const first = readSlidesCache()?.[0];
  const href = slidePreloadSrc(first);
  if (!href) return null;

  const parts = [];
  if (first.imageWebpSm) parts.push(`${first.imageWebpSm} 960w`);
  if (first.imageWebp) parts.push(`${first.imageWebp} 1600w`);

  return {
    href,
    imageSrcSet: parts.length > 1 ? parts.join(', ') : undefined,
    imageSizes: parts.length > 1 ? '100vw' : undefined,
  };
};

export const slideWebpSrcSet = (slide) => {
  const parts = [];
  if (slide?.imageWebpSm) parts.push(`${slide.imageWebpSm} 960w`);
  if (slide?.imageWebp) parts.push(`${slide.imageWebp} 1600w`);
  return parts.join(', ');
};
